<script>
  import TermsCommon from "./TermsCommon.svelte";
  import Terms23 from "./Terms23.svelte";
  import Terms26 from "./Terms26.svelte";
  import { terms } from "../stores.js";
</script>

{#if "23" == $terms}
<Terms23 />
{:else if "26" == $terms}
<Terms26 />
{:else}
<TermsCommon />
{/if}
